import React from 'react';
import { Title, Button, ButtonsGroup } from 'components/commons';
import { ESTIMULO_2020, SEBRAE, AMBEV } from 'constants/constants';
import SebraeDocuments from '../../../components/sebrae-documents';
import bizMitoIcon from 'assets/svg/biz-mito.svg';

import './welcome.style.scss'

type WelcomeLayoutProps = {
    utmSource?: string;
    onOk(): void;
}

const typicalRequiredDocumentation = [
    {
        description: 'Documentos da empresa',
        documents: [
            'Contrato social (última versão com assinaturas e carimbo)',
            'Comprovante de endereço da empresa (conta de luz, água, gás, telefone ou internet com no máximo 90 dias)',
            'Extratos bancários dos últimos 90 dias',
        ],
    },
    {
        description: 'Documentos dos donos',
        documents: [
            'Identidade do(s) sócio(s)',
            'CPF do(s) sócio(s)',
            'Comprovante de residência do(s) sócio(s) (conta de luz, água, gás, telefone ou internet com no máximo 90 dias)',
            'Comprovante de renda do(s) sócio(s) (declaração completa do Imposto de Renda + recido de entrega)',
        ],
    },
];

const ambevRequiredDocumentation = [
    {
        description: 'Documentos da empresa',
        documents: [
            'Contrato social (última versão com assinaturas e carimbo)',
            'Extratos bancários dos últimos 90 dias',
        ],
    },
    {
        description: 'Documentos dos donos',
        documents: [
            'Identidade de um dos sócios da empresa',
            'CPF de um dos sócios da empresa',
        ],
    },
];

const estimuloRequiredDocumentation = [
    {
        description: 'Documentos da empresa',
        documents: [
            'Contrato social',
            'Extratos bancários dos últimos 90 dias',
            'E-mail(s) do(s) sócio(s) administrador(es)'
        ],
    },
    {
        description: 'Documentos de 1 dos sócios administradores da empresa',
        documents: [
            'Identidade ou CNH',
            'CPF',
            'Comprovante de residência do(s) sócio(s) (conta de luz, água, gás, telefone ou internet com no máximo 90 dias)'
        ],
    },
];

const getListOfDocuments = (utmSource) => {
    if (utmSource === ESTIMULO_2020) {
        return estimuloRequiredDocumentation;
    } else if (utmSource === AMBEV) {
        return ambevRequiredDocumentation;
    } else {
        return typicalRequiredDocumentation;
    }
}

const getDisplayedDocuments = (document, nestedKey) => {
    return <li key={nestedKey}>{document}</li>
}

const WelcomeLayout: React.FC<WelcomeLayoutProps> = ({ onOk, utmSource }) => {
    const listOfDocuments = getListOfDocuments(utmSource);

    return (
        <div className="simple-screen welcome">
            <img className="main-icon" src={bizMitoIcon} />

            <Title>
                bem-vindo à biz!
            </Title>

            <h2>
                só falta enviar alguns documentos!
            </h2>

            <p>
                para confirmar seus dados e terminar a sua análise,
                o envio da sua documentação é essencial!
            </p>

            <div className="box-documents">
                <h3>lista de documentos</h3>
                <div className="content-documents">
                    {
                        utmSource === SEBRAE
                            ? <SebraeDocuments />
                            : listOfDocuments.map(({ description, documents }, key) => (
                                <div key={key} >
                                    <h4>{description}</h4>
                                    <ul>{documents.map((document, nestedKey) => getDisplayedDocuments(document, nestedKey))}</ul>
                                </div>
                            ))
                    }
                </div>
                <h3>como enviar</h3>
                <div className="contact-documents">
                    <h4>E-mail</h4>
                    <a href="mailto:documentos@bizcapital.com.br">
                        documentos@bizcapital.com.br
                    </a>
                </div>

                <div className="contact-documents">
                    <h4>WhatsApp</h4>
                    <a href="https://api.whatsapp.com/send?phone=551153300448">
                        (11) 5330-0448
                    </a>
                </div>
            </div>

            <ButtonsGroup mobileStyle="wrap">
                <Button variant="secondary" label="concluir" onClick={onOk} />
            </ButtonsGroup>
        </div>

    )
};

export default WelcomeLayout;
